import { PublicMetadataRepository } from '@lib/api/repository/public-metadata';
import {
  PUBLIC_METADATA,
  PublicPageMetadata,
} from '@lib/types/public-metadata';

import { Requester } from '../clients';

export default class PublicMetadataAPI implements PublicMetadataRepository {
  async find(path: string, signal?: AbortSignal) {
    const endpoint = PUBLIC_METADATA.ENDPOINT.replace(/^\/api/, '');
    const { data } = await Requester.get<PublicPageMetadata>(
      `${endpoint}?path=${encodeURIComponent(path)}`,
      { signal },
    );

    return data;
  }
}
